<template>
  <er-card class="pond-alerts-table" shadow="never">
    <template slot="header">
      <div class="pond__header">
        <p class="pond-alerts-table__header card-title">
          {{ $t("Comn_ponds") }} {{ $t("Comn_alerts") }}
        </p>
        <!-- <er-column-selector
          :key-to-store-defaults="false"
          :columns="pondsForSelection"
          :allowSave="false"
          :allowCheck="true"
          :srcImg="'FILTER_ICON'"
          :type="'ponds'"
          :title="'Pond Visibility'"
          :loading="loading"
          @change-selection="handleChangeInSelectedPonds"
        ></er-column-selector>-->
        <er-list-filter
          :data="arrPondsForSelection"
          value-key="pond_id"
          search-on-key="label"
          :defaultCheckedKeys="getAvailablePondIds"
          @check-change="handleChangeInSelectedPonds"
        >
          <template v-slot:label="{ item }">{{ item.label }}</template>
        </er-list-filter>
      </div>
      <div class="divider" />
    </template>
    <el-row>
      <er-data-tables
        ref="table"
        unique-id="pond-alerts-table__table"
        :key="$i18n.locale"
        layout="table"
        :merge="{ startColumnNumber: 1, endColumnNumber: 3 }"
        :tableData="getFilterTableData"
        :sortMethodForColumns="sortMethodForColumns"
        :columns="tableColumns"
        :total="total"
        :disable-check="false"
        :el-table-props="tableProps"
        :action-column="false"
        v-loading="loading"
        type="white-header-table"
      >
        <template v-slot:device_type="{ row }">
          {{ $t($constants.deviceTypes[row.data.device_type].lang_key) }}
        </template>
        <template v-slot:device_id="{ row }">
          <span :title="row.data.device_code">
            <template
              v-if="
                row.data.device_type === $constants.deviceTypes.SHRIMP_TALK.key
              "
              >{{ stV1Title(row.data.device_code) }}</template
            >
            <template v-else>
              {{ row.data.device_title || row.data.device_code }}
            </template>
          </span>
        </template>
        <template v-slot:status="{ row }">
          <!-- <template v-for="(alert,index) in row.data.arr_error_alerts"> -->
          <el-tooltip
            :content="renderAlertName(row.data.error_code)"
            placement="bottom"
          >
            <img rel="prerender" :src="renderAlertIcon(row.data.error_code)" />
          </el-tooltip>
          <!-- </template> -->
        </template>
        <template v-slot:time="{ row }">
          <span>{{ formatDate(row.data) }}</span>
        </template>
      </er-data-tables>
    </el-row>
  </er-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import ShrimpTalk from "@/model/shrimptalk";
import errorAlertsUtils from "@/utils/errorAlertsUtils";
// import alerts from "@/store/components/alerts";

export default {
  mixins: [errorHandlerMixin],
  name: "PondAlertsTable",
  props: {
    data: Array,
    loading: Boolean
  },
  data: function() {
    return {
      selected_pm: {},
      selectedpond: [],
      selectedAlertTypes: [],
      pmHistory: "",
      total: 0,
      tableProps: {
        border: false,
        stripe: false,
        size: "small",
        defaultSort: {
          prop: "pond_name",
          order: "ascending"
        }
      },
      query: {
        limit: 30,
        page: 1
      }
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function(newLang, oldLang) {
        this.$moment.locale(this.$i18n.locale);
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters("user", {
      getUserTimeZone: "getUserTimeZone"
    }),
    ...mapGetters("pondmother", {
      getObjPmIdPm: "getObjPmIdPm"
    }),
    ...mapGetters("alertsInfo", {
      getFilterTableData: "getFilterTableData",
      getPondsHavingAlerts: "getPondsHavingAlerts"
    }),
    getPondsHavingAlertsSortByTitle() {
      return this.$lodash
        .cloneDeep(this.getPondsHavingAlerts || [])
        .sort((a, b) =>
          this.$commonUtils.alphaNumericComparator(a.title, b.title)
        );
    },
    pondsForSelection() {
      const ponds = this.getPondsHavingAlertsSortByTitle.reduce((acc, x) => {
        acc[x._id] = { pond_id: x._id, label: x.title, default: true };
        return acc;
      }, {});
      return ponds;
    },
    getAvailablePondIds() {
      return Object.keys(this.pondsForSelection);
    },
    arrPondsForSelection() {
      return Object.values(this.pondsForSelection);
    },
    tableColumns() {
      return {
        pond: {
          label: this.$t("Comn_pond"),
          prop: "pond_name",
          sortable: true,
          sortMethod: (a, b) => {
            return this.$commonUtils.alphaNumericComparator(
              a.pond_name || "",
              b.pond_name || ""
            );
          }
        },
        device_type: {
          label: this.$t("Comn_device_type"),
          prop: "device_type",
          sortable: true
        },
        device_id: {
          label: this.$t("Comn_device_id"),
          prop: "pond_mother_code",
          sortable: false
        },
        status: {
          label: this.$t("Comn_alert"),
          prop: "user_priority",
          width: 90,
          sortable: true
        },
        time: {
          label: this.$t("Comn_time"),
          prop: "updated_at",
          minWidth: 120,
          sortable: false
        }
      };
    },
    sortMethodForColumns: function() {
      return {
        user_priority: (a, b) => this.$commonUtils.alphaNumericComparator(a, b)
      };
    },
    stV1Title() {
      return code => {
        return ShrimpTalk.v1Title(code);
      };
    }
  },
  methods: {
    ...mapActions("alertsInfo", {
      changeAlertsFilterSelection: "changeAlertsFilterSelection"
    }),
    handleChangeInSelectedPonds(selectedPonds) {
      const filter = {
        filter_type: "POND",
        filters: selectedPonds || []
      };
      this.changeAlertsFilterSelection(filter);
    },
    renderAlertIcon(alertCode) {
      return errorAlertsUtils.renderDeviceAlertIcon(alertCode);
    },
    renderAlertName(data) {
      return this.$t(errorAlertsUtils.renderAlertName(data));
    },
    handleSort({ column, prop, order }) {
      if (prop === "utc_last_communicated_at") {
        this.data.sort((a, b) => {
          const value1 =
            a.last_communicated_at ||
            a.date ||
            a.utc_last_communicated_at ||
            this.$moment("1970-01-01T00:00:00.000Z");
          const value2 =
            b.last_communicated_at ||
            b.date ||
            b.utc_last_communicated_at ||
            this.$moment("1970-01-01T00:00:00.000Z");
          if (order === "ascending") {
            return this.$moment(value1).diff(this.$moment(value2));
          } else {
            return this.$moment(value2).diff(this.$moment(value1));
          }
        });
      }
    },
    formatDate: function(pond) {
      try {
        if (pond.error_code === "NO_SCHEDULES") return "--";
        return this.$moment
          .utc(pond.date)
          .utcOffset(this.getUserTimeZone.offset)
          .format("YYYY-MM-DD HH:mm:ss");
      } catch (err) {
        return "NA";
      }
    }
  }
};
</script>
<style lang="scss">
.pond-alerts-table {
  overflow: auto;
  .pond__header {
    display: flex;
    justify-content: space-between;
    padding: 8px;
  }
  .el-row--flex {
    padding: 0.5rem;
  }
  &__header {
    font-weight: $font_weight_header;
    color: #0a2463;
    opacity: 0.9;
    @include responsiveProperty(font-size, 1rem, 1.29em, 1.5em);
  }
  .er-data-tables .white-header-table .el-table .el-table__header {
    background-color: transparent;
    border-bottom: 1px solid #ebeef5;
  }
  .el-table {
    border-radius: 0px !important;
    box-shadow: none !important;
    .cell {
      text-align: center;
      font-weight: 500;
    }
  }
  .el-card__body {
    padding: 0px;
  }
  .el-table thead {
    color: #0a2463;
    line-height: 20px;
  }
  .el-table__header th > .cell {
    // height: 30px;
    letter-spacing: 0.3px;
    text-align: center;
    background-color: white;
    font-weight: 600;
  }
  width: 100%;
  .el-table td {
    padding: 0px;
    .cell {
      line-height: 1;
    }
  }
  .el-dialog__body {
    padding: 12px;
    .el-table td,
    .el-table th {
      padding: 0px;
    }
  }
  .el-table__row {
    .cell {
      img {
        @include responsiveProperty(width, 2em, 2em, 1.8em);
        // margin-top: 5px;
        margin: 0px;
        padding: 0px;
        display: flex;
      }
    }
  }
  .divider {
    width: 100%;
    height: 1px;
    opacity: 0.2;
    // margin: 0 auto;
    // display: inline-block;
    background-color: #6c7b8a;
  }
}
</style>
